// App capabilities based on the local Docs overview for each Zild App.
export const agentApps = {
  "assist": {
    "name": "Zild Assist",
    "doc": "zild-assist",
    "channels": [
      "WhatsApp",
      "E-mail",
      "Webchat compatível"
    ],
    "channelsEn": [
      "WhatsApp",
      "Email",
      "Compatible webchat"
    ],
    "reason": "Atendimento por conversa, com contexto e transferência para uma pessoa.",
    "reasonEn": "Conversational service with context and human handoff."
  },
  "chat": {
    "name": "Zild Chat",
    "doc": "zild-chat",
    "channels": [
      "Chat interno no aplicativo web Zild Chat"
    ],
    "channelsEn": [
      "Internal chat in the Zild Chat web app"
    ],
    "reason": "Assistência sob demanda para colaboradores, usando conhecimento e ferramentas aprovados.",
    "reasonEn": "On-demand employee assistance using approved knowledge and tools."
  },
  "flow": {
    "name": "Zild Flow",
    "doc": "zild-tasks",
    "channels": [
      "Tarefas e etapas no aplicativo web Zild Flow"
    ],
    "channelsEn": [
      "Tasks and stages in the Zild Flow web app"
    ],
    "reason": "Execução de etapas, conferências e encaminhamentos dentro de um processo.",
    "reasonEn": "Execution of steps, checks and handoffs within a process."
  },
  "voice": {
    "name": "Zild Voice",
    "doc": "zild-voice",
    "channels": [
      "Telefonia SIP / PSTN — chamadas ativas e receptivas"
    ],
    "channelsEn": [
      "SIP / PSTN telephony — outbound and inbound calls"
    ],
    "reason": "Variante para realizar o contato por telefone, com roteiro e transferência humana configurados.",
    "reasonEn": "A variant for telephone outreach with a configured script and human transfer."
  },
  "coach": {
    "name": "Zild Coach",
    "doc": "zild-coach",
    "channels": [
      "Simulações por voz ou conversa no aplicativo Zild Coach"
    ],
    "channelsEn": [
      "Voice or conversational simulations in the Zild Coach app"
    ],
    "reason": "Variante para praticar cenários e receber avaliação e feedback, além da consulta de conteúdos.",
    "reasonEn": "A variant for practicing scenarios and receiving evaluation and feedback beyond content lookup."
  }
};

export const agentAppProfiles = {
  "Planejador de campanhas": {
    "app": "chat",
    "variants": []
  },
  "Analista de campanhas": {
    "app": "flow",
    "variants": []
  },
  "Qualificador de leads": {
    "app": "assist",
    "variants": [
      "voice"
    ]
  },
  "Roteador comercial": {
    "app": "flow",
    "variants": []
  },
  "Analista de oportunidades": {
    "app": "chat",
    "variants": []
  },
  "Coordenador de follow-up": {
    "app": "assist",
    "variants": [
      "voice"
    ]
  },
  "Consultor técnico": {
    "app": "chat",
    "variants": []
  },
  "Analista de viabilidade": {
    "app": "chat",
    "variants": []
  },
  "Preparador de propostas": {
    "app": "chat",
    "variants": []
  },
  "Revisor de condições": {
    "app": "flow",
    "variants": []
  },
  "Orquestrador de pedidos": {
    "app": "flow",
    "variants": []
  },
  "Monitor de pendências": {
    "app": "flow",
    "variants": []
  },
  "Planejador de materiais": {
    "app": "flow",
    "variants": []
  },
  "Monitor de produção": {
    "app": "flow",
    "variants": []
  },
  "Conferente de produção": {
    "app": "flow",
    "variants": []
  },
  "Coordenador de disponibilidade": {
    "app": "flow",
    "variants": []
  },
  "Monitor de reposição": {
    "app": "flow",
    "variants": []
  },
  "Analista de divergências": {
    "app": "flow",
    "variants": []
  },
  "Coordenador de serviços": {
    "app": "flow",
    "variants": []
  },
  "Conferente de execução": {
    "app": "flow",
    "variants": []
  },
  "Preparador de remessas": {
    "app": "flow",
    "variants": []
  },
  "Monitor de entrega": {
    "app": "flow",
    "variants": []
  },
  "Assistente de separação": {
    "app": "chat",
    "variants": []
  },
  "Tratador de faltas": {
    "app": "flow",
    "variants": []
  },
  "Conferente de volumes": {
    "app": "flow",
    "variants": []
  },
  "Preparador de etiquetas": {
    "app": "flow",
    "variants": []
  },
  "Consolidador de expedição": {
    "app": "flow",
    "variants": []
  },
  "Conferente de carga": {
    "app": "flow",
    "variants": []
  },
  "Conferente de transporte": {
    "app": "flow",
    "variants": []
  },
  "Monitor documental": {
    "app": "flow",
    "variants": []
  },
  "Preparador de manifesto": {
    "app": "flow",
    "variants": []
  },
  "Monitor de viagem documental": {
    "app": "flow",
    "variants": []
  },
  "Preparador de faturamento": {
    "app": "flow",
    "variants": []
  },
  "Validador de cobrança": {
    "app": "flow",
    "variants": []
  },
  "Revisor fiscal": {
    "app": "flow",
    "variants": []
  },
  "Monitor de emissão": {
    "app": "flow",
    "variants": []
  },
  "Agente de cobrança": {
    "app": "assist",
    "variants": [
      "voice"
    ]
  },
  "Conciliador de recebimentos": {
    "app": "flow",
    "variants": []
  },
  "Consolidador de demandas": {
    "app": "flow",
    "variants": []
  },
  "Preparador de consulta": {
    "app": "flow",
    "variants": []
  },
  "Comparador de propostas": {
    "app": "chat",
    "variants": []
  },
  "Analista de pendências": {
    "app": "assist",
    "variants": []
  },
  "Preparador de pedidos de compra": {
    "app": "flow",
    "variants": []
  },
  "Monitor de fornecedores": {
    "app": "flow",
    "variants": []
  },
  "Conferente de três vias": {
    "app": "flow",
    "variants": []
  },
  "Classificador de despesas": {
    "app": "flow",
    "variants": []
  },
  "Organizador de pagamentos": {
    "app": "flow",
    "variants": []
  },
  "Detector de duplicidades": {
    "app": "flow",
    "variants": []
  },
  "Projetor de caixa": {
    "app": "chat",
    "variants": []
  },
  "Analista de desvios": {
    "app": "chat",
    "variants": []
  },
  "Conciliador contábil": {
    "app": "flow",
    "variants": []
  },
  "Organizador de evidências": {
    "app": "flow",
    "variants": []
  },
  "Monitor de integrações": {
    "app": "flow",
    "variants": []
  },
  "Assistente de suporte": {
    "app": "assist",
    "variants": []
  },
  "Coordenador de onboarding": {
    "app": "flow",
    "variants": []
  },
  "Tutor corporativo": {
    "app": "chat",
    "variants": [
      "coach"
    ]
  }
};
